<div class="tableInfo">
  <h2 class="titleTable">Tipo de caso</h2>

  <!-- <div class="select">
    <mat-form-field class="matform" appearance="outline">
      <mat-label>Unidad</mat-label>
      <mat-select
        (selectionChange)="getDataUnitCaseType()"
        [(ngModel)]="unitSelected"
      >
        <mat-option *ngFor="let unit of units" [value]="unit">{{
          unit.name
        }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div> -->
  <mat-table *ngIf="res" [dataSource]="dataSource" class="mat-elevation-z8">
    <div *ngFor="let labels of res.labelsUnitTable">
      <ng-container [matColumnDef]="labels">
        <mat-header-cell *matHeaderCellDef>{{ labels }} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element[labels] }}
        </mat-cell>
      </ng-container>
    </div>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>
</div>
<div class="graphics">
  <h1 class="title">Total por tipo de caso</h1>
  <div class="divChart" id="contentCaseTypeReportResume">
    <canvas id="CaseTypeReportResume" width="30"></canvas>
  </div>
</div>
<div class="graphics">
  <h1 class="title">Total por tipo de caso/Estátus</h1>
  <div class="divChart" id="contentCaseTypeReportResumeStatus">
    <canvas id="CaseTypeReportResumeStatus" width="30"></canvas>
  </div>
</div>
